import { initGA } from './analytics';
import { initMetaPixel } from './metaPixel';

declare global {
  interface Window {
    _axcb?: ((sdk: any) => void)[];
  }
}

export const setupAnalyticsWithConsent = () => {
  if (typeof window === 'undefined') return;

  window._axcb = window._axcb || [];

  window._axcb.push(function (sdk: any) {
    let previousGA = sdk.hasAcceptedVendor('google_analytics');
    let previousMeta = sdk.hasAcceptedVendor('meta_pixel');

    // Appliquer l'état initial si déjà consenti lors d'une visite précédente (état initial)
    if (previousGA) initGA();

    if (previousMeta) initMetaPixel();

    sdk.on('cookies:complete', function () {
      const hasGA = sdk.hasAcceptedVendor('google_analytics');
      const hasMeta = sdk.hasAcceptedVendor('meta_pixel');

      // Activation : le SDK n'a pas encore été init, on l'initialise maintenant
      if (hasGA && !previousGA) initGA();

      if (hasMeta && !previousMeta) initMetaPixel();

      // Désactivation : le SDK est déjà chargé, on recharge la page
      if ((!hasGA && previousGA) || (!hasMeta && previousMeta)) {
        window.location.reload();
        return;
      }

      previousGA = hasGA;
      previousMeta = hasMeta;
    });
  });
};

